/* eslint no-underscore-dangle: 0 */
import { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import dayjs from 'utils/dayjs';
import { fromInstant } from 'utils/timezone';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import Side from '../partials/SideBar';
import CounsellorWaiting from './CounsellorWaiting';
import { fetchAppointment } from '../../../actions/sessions';
import {
  updateUserAppointment,
  fetchUserAppointment,
} from '../../../ducks/sessions/userAppointment';

function WaitingRoom({
  fetchAppointment: fetchAppointmentAction,
  match,
  me,
  fetchUserAppointment: fetchUserAppointmentAction,
  updateUserAppointment: updateUserAppointmentAction,
  userAppointment = {},
  ...rest
}) {
  const [button_disabled, setButtonDisabled] = useState(true);
  const [countdown, setCountdown] = useState(undefined);
  const isMountedRef = useRef(false);
  const intervalID = useRef(null);
  const propsRef = useRef({
    fetchUserAppointmentAction,
    match,
    userAppointment,
  });
  propsRef.current = {
    fetchUserAppointmentAction,
    match,
    userAppointment,
  };

  const otherUserWaiting = () => {
    const {
      fetchUserAppointmentAction: fetchOther,
      match: currentMatch,
      userAppointment: currentUserAppointment,
    } = propsRef.current;

    fetchOther(currentMatch.params.id, '?other_user=true');

    return currentUserAppointment
      ? currentUserAppointment.waiting_yn
      : false;
  };

  const countdownTimer = time => {
    let newTime = time;
    const interval = 1000;
    const oneHour = 3600000;
    const threeMinutes = 180000;
    intervalID.current = setInterval(() => {
      if (newTime - interval > 0) newTime -= interval;
      else newTime = 0;

      const d = dayjs.duration(newTime);
      const s = Math.floor(d.asHours()) + dayjs.utc(newTime).format(':mm:ss');
      setCountdown(s);

      // checks if its between 3 minutes and 0
      if (
        (newTime >= -threeMinutes && newTime <= 0) ||
        otherUserWaiting()
      ) {
        clearInterval(intervalID.current);
        setCountdown(
          <FormattedMessage defaultMessage="Your Session is Ready" />,
        );
        setButtonDisabled(false);
      }

      // checks if its been over 1 hours
      if (newTime < -oneHour) {
        clearInterval(intervalID.current);
        setCountdown(
          <FormattedMessage defaultMessage="This session has expired" />,
        );
        setButtonDisabled(true);
      }
    }, interval);
  };

  useEffect(() => {
    isMountedRef.current = true;
    fetchAppointmentAction(match.params.id, response => {
      const now = fromInstant(new Date());
      const then = dayjs.utc(response.data.start_date);
      const ms = then.diff(now);
      updateUserAppointmentAction(
        response.data.id,
        { waiting_yn: true },
        () => {
          if (isMountedRef.current) {
            countdownTimer(ms);
          }
        },
      );
    });

    return () => {
      isMountedRef.current = false;
      clearInterval(intervalID.current);
    };
    // Match class componentDidMount / WillUnmount lifecycle.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const props = {
    fetchAppointment: fetchAppointmentAction,
    match,
    me,
    fetchUserAppointment: fetchUserAppointmentAction,
    updateUserAppointment: updateUserAppointmentAction,
    userAppointment,
    ...rest,
  };
  const state = {
    button_disabled,
    countdown,
  };

  return (
    <div className="row no-gutters" style={{ height: '100%' }}>
      <div className="col-2">
        <Side color="#e6f9f7" />
      </div>
      <div
        className="col-10"
        style={{ paddingTop: '100px', paddingLeft: '30px' }}
      >
        {CounsellorWaiting(props, state)}
      </div>
    </div>
  );
}

WaitingRoom.propTypes = {
  fetchAppointment: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  me: PropTypes.object.isRequired,
  fetchUserAppointment: PropTypes.func.isRequired,
  updateUserAppointment: PropTypes.func.isRequired,
  userAppointment: PropTypes.object,
};

function mapStateToProps(state) {
  const assessments = _.get(state, 'session.appointment.pre_assessment');
  const initalAssessmentValues = _.map(assessments, o => ({ [o.id]: o.value }));
  const initialValues = Object.assign({}, ...initalAssessmentValues);
  const appointment = _.get(state, 'session.appointment');
  let url;

  if (appointment) {
    if (appointment.modality === 'In Person') {
      url = 'in_person';
    } else if (appointment.modality === 'Video') {
      url = 'video_call';
    } else if (appointment.modality === 'Voice') {
      url = 'voice_call';
    }
  }

  return {
    me: state.user,
    appointment,
    preAssessment: _.get(state, 'session.appointment.pre_assessment'),
    initialValues,
    userAppointment: state.ducks.sessions.userAppointment,
    url,
  };
}

export default connect(mapStateToProps, {
  fetchAppointment,
  fetchUserAppointment,
  updateUserAppointment,
})(WaitingRoom);
